import React from 'react';
import Image from 'assets/images/png/bg-grocery-4.jpg';

function PageTitle({ title }) {
  return (
    <div
      className='page-nav md-mt-6'
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12 text-center'>
            <h1>{title}</h1> <span>Home / {title}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageTitle;
